'use client';

import React from 'react';
import { useUserSettings } from 'src/hooks/users';
import { NavCallout } from '../NavCallout';

const SETTING_KEY = 'hasSeenMoreMenuChangesV2';

interface MoreMenuCalloutProps {
  triggerRef: React.RefObject<HTMLDivElement | null>;
}

const MoreMenuCallout = ({ triggerRef }: MoreMenuCalloutProps) => {
  const { getSetting, setSetting, isHydrated } = useUserSettings();

  const hasSeen = getSetting<boolean>(SETTING_KEY) === true;
  const shouldShow = isHydrated && !hasSeen;

  if (!shouldShow) return null;

  return (
    <NavCallout
      triggerRef={triggerRef}
      title="Reports & Exports moved here!"
      description="Find Reports and Exports in the More menu."
      onDismiss={() => setSetting(SETTING_KEY, true)}
    />
  );
};

export default MoreMenuCallout;
